export function safeImageUrl(url: string | null | undefined): string | null {
	if (!url) return null;
	return url.startsWith("https://") || url.startsWith("http://") ? url : null;
}
